<section class="irrigator-bottom-cards" aria-label="Mis parcelas">
  <aside class="irrigator-highlight-card">
    <h3>Mis parcelas</h3>
    <div>
      <span class="parcel-shape" aria-hidden="true"></span>
      <p>Tus parcelas están resaltadas en el mapa</p>
    </div>
    <button type="button" (click)="parcelsPanelRequested.emit()">Ver mis parcelas</button>
  </aside>
</section>
